import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n.jsx";
import i18n from "./i18n.jsx";

// Build sirasinda prerender edilen statik SEO etiketlerini mount oncesi kaldir;
// Helmet kendi etiketlerini ekledigi icin aksi halde her rotada cift canonical /
// description / og seti olusur (dil degistiginde degerleri de celisir).
document.querySelectorAll("head [data-prerender]").forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// HTML lang attribute'ını aktif dile göre güncelle (RTL için gerekli)
i18n.on("languageChanged", (lng) => {
    if (typeof document !== "undefined") {
        document.documentElement.setAttribute("lang", lng);
    }
});
// İlk yüklemede de ayarla
if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", i18n.language);
}
